
import { Input } from "@progress/kendo-vue-inputs";
import { defineComponent } from "vue";

export default defineComponent({
  name: "IInput",
  components: {
    "k-input": Input,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    valid: {
      type: Boolean,
    },
  },
});
